import { ButtonSiguiente } from "@/components/ui";
import { UsuarioDetalle } from "@/types";
import { useEffect } from "react";

const timeZone = "Europe/Madrid";

function formatDate(dateLike?: string | Date | null) {
  if (!dateLike) return "-";
  const d = new Date(dateLike);
  if (isNaN(d.getTime())) return "-";
  return new Intl.DateTimeFormat("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone,
  }).format(d);
}

function formatTime(dateLike?: string | Date | null) {
  if (!dateLike) return "-";
  const d = new Date(dateLike);
  if (isNaN(d.getTime())) return "-";
  return new Intl.DateTimeFormat("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone,
  }).format(d);
}

interface DetalleUsuarioAdminProps {
  usuario: UsuarioDetalle;
  onBack: () => void;
}


const DetalleUsuarioAdmin: React.FC<DetalleUsuarioAdminProps> = ({
  usuario,
  onBack,
}) => {
  useEffect(() => {
    return () => {
      // limpiar scroll congelado
      window.scrollTo(0, 0);
    };
  }, []);
  
  return (
    <div className="bg-white p-4 rounded shadow space-y-6">
      <h3 className="font-bold text-lg text-blue-700">
        📄 Detalle completo de usuario
      </h3>

      {/* USUARIO */}
      <section className="space-y-1">
        <p><b>ID:</b> {usuario.usuario_id}</p>
        <p><b>Usuario:</b> @{usuario.nombre_usuario}</p>
        <p><b>Nombre:</b> {usuario.nombre} {usuario.apellidos}</p>
        <p><b>Email:</b> {usuario.email}</p>
        <p><b>Rol:</b> {usuario.roles?.[0] ?? "-"}</p>
        <p>
          <b>Creado:</b>{" "}
          {formatDate(usuario.creado_en)}{" "}
          <span className="text-sm text-zinc-500">
            ({formatTime(usuario.creado_en)})
          </span>
        </p>
      </section>

      {/* PROFESIONALES */}
      <section className="space-y-4">
        <h4 className="font-semibold">
          🏢 Profesionales asociados ({usuario.profesionales.length})
        </h4>

        {usuario.profesionales.map((p) => (
          <div
            key={p.profesional_id}
            className="border rounded p-3 bg-zinc-50 space-y-2"
          >
            <h5 className="font-bold text-zinc-800 text-center text-lg">
              {p.nombre_profesion}
            </h5>

            <p><b>Empresa:</b> {p.nombre_empresa}</p>
            <p><b>CIF:</b> {p.cif}</p>
            {p.descripcion && (
              <p><b>Descripción:</b><br />{p.descripcion}</p>
            )}

            {p.direccion && (
              <div>
                <b>📍 Dirección</b>
                <p>
                  {p.direccion.calle}<br />
                  {p.direccion.ciudad} ({p.direccion.cp})<br />
                  {p.direccion.provincia}
                </p>
              </div>
            )}

            <div>
              <b>☎️ Contacto</b>
              <p>Teléfonos: {p.telefonos.length ? p.telefonos.join(", ") : "-"}</p>
              <p>Emails: {p.correos.length ? p.correos.join(", ") : "-"}</p>
            </div>

            <div>
              <b>💳 Suscripciones</b>
              {p.suscripciones.length === 0 ? (
                <p>No tiene suscripciones</p>
              ) : (
                p.suscripciones.map((s, i) => (
                  <div key={i} className="border rounded p-2 mt-2">
                    <p><b>Estado:</b> {s.estado}</p>
                    <p>
                      <b>Periodo:</b><br />
                      Inicio → {formatDate(s.fecha_inicio)} {formatTime(s.fecha_inicio)}<br />
                      Fin → {formatDate(s.fecha_fin)} {formatTime(s.fecha_fin)}
                    </p>
                    <p><b>Monto:</b> {s.monto} {s.moneda ?? "EUR"}</p>
                  </div>
                ))
              )}
            </div>
          </div>
        ))}
      </section>

      <ButtonSiguiente
        onClick={onBack}
        className="w-full bg-gray-300 hover:bg-gray-400"
      >
        ⬅ Volver
      </ButtonSiguiente>
    </div>
  );
};

export default DetalleUsuarioAdmin;
